import { gql } from '@apollo/client';

export const ANY_ALERT_AVAILABLE = gql`
  query anyAlertAvailable {
    alertOpen @client
    alertSeverity @client
    alertMessage @client
  }
`;
